import { useEffect, useState } from "react";
import { initializePendo, getOrganizationAndDeviceSettings } from "../utils/shared/pendo.js";

const usePendo = (isOpen) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const orgSettings = getOrganizationAndDeviceSettings();

    useEffect(() => {
        if (!isInitialized && orgSettings && isOpen) {
            initializePendo(orgSettings);
            setIsInitialized(true);
        }
    }, [isInitialized, isOpen]);
};

export default usePendo;
